








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ColorPicker extends Vue {
  @Prop() color!: string;
  @Prop() event: void;
}
